// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToStartOfChain, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToHomePage } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import { xngOktaSignOut } from "@rc/App/Services/SignOut/SignOut";

let oktaReturnUrl: any;

export const XngOktaSignOut: Handler<any> = async props => {
    try {
        oktaReturnUrl = await xngOktaSignOut();
    } catch (e) {
        props.parameter?.onError?.(e && ((e.errorJson && e.errorJson.message) || e.errorMessage || e.message || e));
    }
}

export const XngRedirectToHomePage = (props: any) => {
    const state = props.getState();
    if (oktaReturnUrl || props.parameter.returnUrl) {
        window.location.href = oktaReturnUrl || props.parameter.returnUrl;
    } else {
        window.location.href = getHomePageUrl(state);
    }
};

addToStartOfChain(chain, XngOktaSignOut);
replaceInChain(chain, RedirectToHomePage, XngRedirectToHomePage);
